import { Component, inject, signal } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { SignalsStoreService } from '../../signals-store.service';
import { CurrencyPipe, Location } from '@angular/common';
import { LocalStorageService } from '../../local-storage.service';
import { LOCALSTORAGE_KEYS } from '../../constants/databases';
import { Session } from '../../types/session.type';
import { AccountService } from '../../account.service';

@Component({
  selector: 'app-pending-payment-method',
  providers: [provideNativeDateAdapter()],
  imports: [CurrencyPipe],
  template: `
    <div class="container">
      <div class="row">
        <div class="col mb-3 text-center">
          <small>
            Payment Method Required
          </small>
          <br>
          <small>
            To activate your
            @if (membershipCharge()) {
              {{ membershipCharge() | currency:'USD':'symbol':'1.0-2' }}
            }
            annual membership and start shopping, please add a payment method now. This unlocks full access to The Produce Box—bringing fresh, local food straight to your door with ease.
          </small>
        </div>
      </div>

      <div class="row mt-0 mb-2 justify-content-center">
        <div class="col-md-auto">
          <button
            type="button"
            class="btn btn-primary"
            (click)="addPaymentMethod()"
          >
            Add Payment Method
          </button>
        </div>
      </div>
    </div>
  `
})
export class PendingPaymentMethodComponent {
  private signalsStoreService = inject(SignalsStoreService)
  private location = inject(Location);
  #localStorageService = inject(LocalStorageService);
  #accountService = inject(AccountService);

  /**
   * The membership price, only once the backend has confirmed it (DEV-11833). Until then, and
   * whenever it can't say, the copy carries no amount: a figure from the session could be from
   * before a price change, and a wrong one is worse than none.
   */
  membershipCharge = signal(0);

  constructor() {
    this.#accountService.getSignupMembershipCharge().subscribe(charge => this.membershipCharge.set(charge));
  }

  /**
   * Someone the backend marks as abandoned never registered a card: they are a signup left
   * half-finished, not a customer whose card stopped working. Settings charges the membership
   * just the same, but it sits outside the signup — the one place the conversion is measured —
   * so their completed registration never reached GA4 (DEV-11068). Back to the signup, then,
   * which resumes at the membership step. Anyone else keeps going to Settings.
   */
  addPaymentMethod() {
    const session: Session | null = this.#localStorageService.get(LOCALSTORAGE_KEYS.SESSION);
    this.reloadPage(session?.settings?.isAbandoned ? '/signup' : '/settings/billing/payment-method');
  }

  reloadPage(route: string) {
    // Setting step 3 
    this.signalsStoreService.signUpStep.set(2)
    this.location.replaceState(route);
    window.location.reload();
  }
}
